import React, { Component } from 'react';
import Header from '../../Components/Header/';
import Table from '../Table/';
import LoaderScreen from '../../Components/LoaderScreen/';
import WorkoutDescription from '../../Components/WorkoutDescription/';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import './App.css';


const theme = createMuiTheme({
  overrides: {
    // Name of the component ⚛️ / style sheet
    MuiButton: {
      // Name of the rule
      outlined: {
        // Some CSS
        background: '#E8E8E8;',
        border: '1px solid rgba(0, 0, 0, 0);'
      },
    },
    MuiDialog: {
      paper: {
        '@media (max-width: 600px)': {
          margin: '48px 42px !important'
        }
      }
    }
  },
  palette: {
    primary: {
      light: '#ED785E',
      main: '#e84924',
      dark: '#DC3C18'
    },
    secondary: {
      light: '#1887DC',
      main: '#1264a3',
      dark: '#0A3B60'
    }
  },
  typography: { useNextVariants: true }
});

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      name: '',
      getUrlLocation: '',
      currentList: [],
      currentPageNumber: 1,
      leaderboardId: 274,
      backupLeaderboardId: 1,
      lastPageNumber: 10,
      divisionId: process.env.REACT_APP_DIVISION_ROOT,
      backupDivisionId: process.env.REACT_APP_DIVISION_SECONDARY,
      eventConfig: {},
      activeEventId: -1,
      reverse: false,
      hideHeader: false,
      hideWorkoutDescription: true,
      updatedAt: undefined
    }

    this.updateName = this.updateName.bind(this);
    this.getPage = this.getPage.bind(this);
    this.getLeaderboard = this.getLeaderboard.bind(this);
    this.updatePage = this.updatePage.bind(this);
    this.updateScrollTo = this.updateScrollTo.bind(this);
    this.switchLeaderboards = this.switchLeaderboards.bind(this);
    this.toggleWorkoutDescription = this.toggleWorkoutDescription.bind(this);
  }

  componentDidMount() {
    this.getLeaderboard(true);
    if(window.location.search) {
      let getRidOfHeader = window.location.search.split('?header=');
      if(getRidOfHeader[1]) this.setState({
        hideHeader: getRidOfHeader[1]
      });
    }
  }

  updateName(name) {
    this.setState({
      name: name.toString()
    });
  }

  getPage(number, leaderboard, scrollTo, init) {

    let catchNumber = isNaN(number) ? 1 : number;
    const catchLeaderboard = leaderboard ? leaderboard : this.state.leaderboardId;
    let reverse = false;

    if(catchLeaderboard === this.state.leaderboardId && this.state.currentPageNumber === catchNumber && init !== true && !scrollTo) {
      reverse = !this.state.reverse;
      catchNumber = this.state.lastPageNumber;
    }

    this.setState({
      loading: true
    });

    if(catchNumber === 0) {
      return this.setState({
        loading: false,
        currentList: []
      })
    }

    let urlToGet = 'https://crossfit.btwb.com/tiggy/crossfitgames2020-' + this.state.divisionId + '-production-' + catchNumber + '.json';

    return fetch(urlToGet, {

    }).then(res => {
      if(!res.ok) {
        throw Error(res.statusText);
      }
      return res.json();
    }).then(data => {
      this.setState({
        currentList: (reverse ? data.leaderboard.reverse() : data.leaderboard),
        currentPageNumber: catchNumber,
        loading: false,
        reverse: reverse,
        activeEventId: -1,
        updatedAt: data.updated_at
      }, () => {
        if(scrollTo) {
          this.updateScrollTo(scrollTo);
        } else {
          this.setState({scrollTo: undefined})
        }
      })
    }).catch(err => {
      console.log(err);
      this.setState({
        loading: false,
        currentList: []
      })
    });
  }

  updatePage(page, emptyVal, scrollTo, leaderboard, divisionId) {
    // I hate this
    let getLeaderboardInstead = false;

    let leaderboardId = leaderboard ? leaderboard : this.state.leaderboardId;
    let backupLeaderboardId = leaderboard ? (
      leaderboard === this.state.leaderboardId ? this.state.backupLeaderboardId : this.state.leaderboardId
    ) : this.state.backupLeaderboardId;

    let letActualPage = page ? page : 0;
    if(backupLeaderboardId !== this.state.backupLeaderboardId) getLeaderboardInstead = true;
    this.setState({
      // hack, if passing through a leaderboard then it has to be coming from search
      leaderboardId: leaderboardId,
      backupLeaderboardId: backupLeaderboardId,
      divisionId: divisionId ? divisionId.toString() : this.state.divisionId,
      backupDivisionId: divisionId ? (divisionId === this.state.divisionId ? this.state.backupDivisionId : this.state.divisionId) : this.state.backupDivisionId
    }, () => {
      this.getPage(letActualPage, this.state.leaderboardId, scrollTo);
    });
  }

  getLeaderboard(init, eventIdToGet, pointsHack) {
    let activeEventId = pointsHack ? -1 : this.state.activeEventId;

    this.setState({
      loading: true,
      activeEventId: activeEventId
    });

    fetch('https://crossfit.btwb.com/tiggy/crossfitgames2020-' + this.state.backupDivisionId + '-production.json', {
    }).then(res => {
      if(!res.ok) {
        throw Error(res.statusText);
      }
      return res.json();
    }).then(data =>{
      this.setState({
        backupLeaderboardId: 3665//data.LeaderboardId,
      }, () => {
        
      })
    }).catch(err => {
      console.log(err);
      this.setState({
        loading: false
      })
    });

    return fetch('https://crossfit.btwb.com/tiggy/crossfitgames2020-' + this.state.divisionId + '-production.json', {
    }).then(res => {
      if(!res.ok) {
        throw Error(res.statusText);
      }
      return res.json();
    }).then(data =>{
      if(pointsHack) {
        window.scrollTo(0, 0);
      }
      this.setState({
        leaderboardId: 3410,//data.LeaderboardId,
        lastPageNumber: data.pages,
        eventConfig: data.Config ? JSON.parse(data.Config) : {}
      }, () => {
        return this.getPage(1, undefined, undefined, (pointsHack && activeEventId !== -1 ? true : init));
      })
    }).catch(err => {
      console.log(err);
      this.setState({
        loading: false
      })
    });

  }

  updateScrollTo(val) {
    this.setState({
      scrollTo: parseInt(val)
    }, () => {
      this.setState({scrollTo: undefined});
    })
  }

  switchLeaderboards(divisionId, backupDivisionId) {
    if(this.state.divisionId === divisionId) return;
    this.setState({
      divisionId: divisionId,
      backupDivisionId: backupDivisionId
    }, () => {
      return this.getLeaderboard(true, false);
    })
  }

  handleAutoSuggestChange(name, eventName) {
    let member = this.state.member;
    member.gym = eventName;
    this.setState({member: member})
  }

  toggleWorkoutDescription() {
    let currentState = this.state.hideWorkoutDescription;

    this.setState({
      hideWorkoutDescription: !currentState
    })
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <div className="App">
          <Header 
            currentName={this.state.name}
            updateName={this.updateName}
            updatePage={this.updatePage}
            leaderboardId={this.state.leaderboardId}
            backupLeaderboardId={this.state.backupLeaderboardId}
            hideHeader={this.state.hideHeader}
            toggleWorkoutDescription={this.toggleWorkoutDescription}
            hideWorkoutDescription={this.state.hideWorkoutDescription}
          />
          {(!this.state.hideHeader && !this.state.hideWorkoutDescription) &&
            <WorkoutDescription />
          }
          <Table
            data={this.state.currentList ? this.state.currentList : []}
            loading={this.state.loading}
            currentPageNumber={this.state.currentPageNumber}
            leaderboardId={this.state.leaderboardId}
            lastPageNumber={this.state.lastPageNumber}
            scrollTo={this.state.scrollTo}
            eventConfig={this.state.eventConfig}
            getLeaderboard={this.getLeaderboard}
            activeEventId={this.state.activeEventId}
            reverse={this.state.reverse}
            divisionId={this.state.divisionId}
            switchLeaderboards={this.switchLeaderboards}
            getPage={this.getPage}
            updatePage={this.updatePage}
            updatedAt={this.state.updatedAt}
          />
          <LoaderScreen
            loading={this.state.loading}
          />
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;
